module.exports = __webpack_public_path__ + "img/back_arrow.e09773c8.png";